import Swiper, { Lazy, Navigation, Zoom } from "swiper";

const SingleProject = {
  init() {
    SingleProject.related();
    SingleProject.gallery();
    this.lightbox();
  },

  gallery() {
    const slider_dom = $(".gallery-slider");

    if (!slider_dom.length) {
      return;
    }

    const wrap = slider_dom.closest(".project-gallery");

    const nav_prev = wrap.find(".swiper-button-prev");

    const nav_next = wrap.find(".swiper-button-next");

    const slides_count = $(".project-gallery").find(".swiper-slide");
    const slides_count_dup = $(".project-gallery").find(".swiper-slide-duplicate");

    new Swiper( slider_dom[0], {
      spaceBetween: 30,
      slidesPerView: 1,
      loop: true,
      zoom: true,
      modules: [ Lazy, Navigation ],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      on: {
        init: function (e){
          $('#currentSlide').html( (e.realIndex +  1) + ' / ' + (slides_count.length - slides_count_dup.length) );
        },
        slideChange: function (e){
          $('#currentSlide').html( (e.realIndex +  1) + ' / ' + (slides_count.length - slides_count_dup.length) );
        }
      },
    });
  },

  related() {
    const slider_dom = $(".related-slider");

    if (!slider_dom.length) {
      return;
    }

    const wrap = slider_dom.closest(".related-products");

    const slides = $(".related-products").attr('data-count');

    const nav_prev = wrap.find(".swiper-button-prev");

    const nav_next = wrap.find(".swiper-button-next");

    new Swiper( slider_dom[0], {
      spaceBetween: 30,
      loop: parseInt( slides ) > 3 ? true : false,
      modules: [ Lazy, Navigation ],
      lazy: {
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      navigation: {
        prevEl: nav_prev[0],
        nextEl: nav_next[0],
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        900: {
          slidesPerView: 3,
        },
      },
    });
  },

  lightbox() {
    // swiper + lightbox
    let swiper;
    window.globals = {};
    const body = document.getElementsByTagName("body")[0];
    const lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
    const initLightbox = lightboxImages.length > 0;
    const destroySwiper = (swiper, timeout) => {
      setTimeout(() => {
        swiper.destroy();
      }, timeout);
    };


    const createLightboxSkeleton = () => {
      // Create skeleton for lightbox
      const lightbox = document.createElement("div");
      const lightboxContainer = document.createElement("div");
      const lightboxClose = document.createElement("div");
      const swiperContainer = document.createElement("div");
      const swiperWrapper = document.createElement("div");
      const swiperBtnNext = document.createElement("div");
      const swiperBtnPrev = document.createElement("div");
      const swiperPagination = document.createElement("div");

      // Add classes
      lightbox.classList.add("c-lightbox");
      lightboxContainer.classList.add("c-lightbox__container");
      lightboxClose.classList.add("c-lightbox__close");
      lightboxClose.setAttribute("tabindex", "0");
      lightboxClose.innerHTML = "X";
      swiperContainer.classList.add("swiper-container");
      swiperWrapper.classList.add("swiper-wrapper");
      swiperBtnNext.classList.add("swiper-button-next");
      swiperBtnPrev.classList.add("swiper-button-prev");
      swiperBtnNext.classList.add("c-next");
      swiperBtnPrev.classList.add("c-prev");
      swiperPagination.classList.add("swiper-pagination");

      // Append created divs
      lightboxContainer.appendChild(lightboxClose);
      swiperContainer.appendChild(swiperWrapper);
      swiperContainer.appendChild(swiperBtnNext);
      swiperContainer.appendChild(swiperBtnPrev);
      swiperContainer.appendChild(swiperPagination);
      lightboxContainer.appendChild(swiperContainer);
      lightbox.appendChild(lightboxContainer);
      body.appendChild(lightbox);

      // Set variables to reference the lightbox
      globals.lightboxRef = document.querySelector(".c-lightbox");
      globals.swiperWrapperRef = document.querySelector(
        ".c-lightbox .swiper-wrapper"
      );
    };

    if (initLightbox) {
      createLightboxSkeleton();

      // The rest of the code will go here
      lightboxImages.forEach(function (el, index) {
        // Add click function to lightbox images
        el.addEventListener("click", imageClick, false);
        // console.log(el)
        function imageClick() {
          // Clear swiper before trying to add to it
          globals.swiperWrapperRef.innerHTML = "";

          // Loop through images with lightbox data attr
          // Create html for lightbox carousel
          lightboxImages.forEach(function (img) {
            // Create clone of current image in loop
            const image = img.cloneNode(true);
            image.setAttribute("src", img.getAttribute("large"));
            // Create divs
            const slide = document.createElement("div");
            const imageContainer = document.createElement("div");
            // Add classes
            slide.classList.add("swiper-slide");
            imageContainer.classList.add("c-lightbox__image");
            imageContainer.classList.add("swiper-zoom-container");
            // Append images to the slides, then slides to swiper wrapper
            imageContainer.appendChild(image);
            slide.appendChild(imageContainer);
            globals.swiperWrapperRef.appendChild(slide);
          });

          // Init Swiper
          swiper = new Swiper(".c-lightbox .swiper-container", {
            direction: 'horizontal',
            initialSlide: index,
            loop: true,
            slidesPerView: 1,
            speed: 750,
            spaceBetween: 16,
            watchOverflow: true,
            modules: [ Zoom, Navigation ],
            navigation: {
              nextEl: ".c-next",
              prevEl: ".c-prev",
            },
            zoom: true,
            fadeEffect: {
              crossFade: false,
            },
            keyboard: {
              enabled: true,
              onlyInViewport: true,
            },
            mousewheel: {
              sensitivity: 1,
              forceToAxis: true,
              invert: true,
            },
          });

          // Add the class to open the lightbox
          // Add overflow hidden to the body to prevent scrolling
          globals.lightboxRef.classList.add("open");
          body.classList.add("overflowHidden");
        }
      });

      // Close lightbox on click
      document.addEventListener(
        "click",
        ({ target }) => {
          if (target.matches(".c-lightbox__close")) {
            destroySwiper(swiper, 250);
            globals.lightboxRef.classList.remove("open");
            body.classList.remove("overflowHidden");
          }
        },
        false
      );

      // Close lightbox on escape key press
      document.addEventListener("keydown", ({ key }) => {
        if (key === "Escape") {
          destroySwiper(swiper, 250);
          globals.lightboxRef.classList.remove("open");
          body.classList.remove("overflowHidden");
        }
      });
    }
  },

};

export default SingleProject;
